module.exports = __webpack_public_path__ + "img/bullseye-pointer.c92d9acd.svg";